import { currentUserId } from './meta';
import { parseWorkspacePath } from './workspaceRoutes';

const getWorkspaceChannelKey = (workspaceId) => {
  const userId = currentUserId();
  return userId && workspaceId ? `output:last-workspace-channel:${userId}:${workspaceId}` : null;
};

export const rememberWorkspaceChannelRoute = (pathname) => {
  const route = parseWorkspacePath(pathname);
  const channelId = route?.relativePath.match(/^\/chats\/([^/]+)/)?.[1];
  const workspaceChannelKey = route?.workspaceId ? getWorkspaceChannelKey(route.workspaceId) : null;
  if (!workspaceChannelKey || !channelId) return;

  try {
    sessionStorage.setItem(workspaceChannelKey, channelId);
  } catch {
    // noop
  }
};

export const getRememberedWorkspaceChannelId = (workspaceId) => {
  try {
    const workspaceChannelKey = getWorkspaceChannelKey(workspaceId);
    return workspaceChannelKey ? sessionStorage.getItem(workspaceChannelKey) : null;
  } catch {
    return null;
  }
};
